(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6545],{

/***/ 6545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content019": function() { return /* binding */ Content019; },
  "default": function() { return /* binding */ Content019_Content019; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content019/Content019.module.scss
var Content019_module = __webpack_require__(87580);
var Content019_module_default = /*#__PURE__*/__webpack_require__.n(Content019_module);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./src/components/widgets/content/Content019/SwiperItem.module.scss
var SwiperItem_module = __webpack_require__(17845);
var SwiperItem_module_default = /*#__PURE__*/__webpack_require__.n(SwiperItem_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content019/SwiperItem.jsx





var SwiperItem = function(param) {
    var children = param.children, swiperRef = param.swiperRef, prevRef = param.prevRef, nextRef = param.nextRef, autoHeight = param.autoHeight, paginationWrapper = param.paginationWrapper;
    var pagination = {
        el: ".".concat(paginationWrapper),
        clickable: true,
        type: "fraction",
        renderFraction: function(currentClass, totalClass) {
            return '<span class="'.concat(currentClass, " ").concat((SwiperItem_module_default())["pagination-current"], '"></span><span class="').concat(totalClass, '"></span>');
        }
    };
    var ref = (0,react.useState)(null), _ = ref[0], setInit = ref[1];
    (0,react.useEffect)(function() {
        swiperRef.current.controller.control = swiperRef.current;
        swiperRef.current.controller.control = swiperRef.current;
    }, [
        swiperRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Pagination */.tl,
            swiper_esm/* Controller */.Qr
        ],
        observer: true,
        pagination: pagination,
        navigation: {
            prevEl: prevRef.current,
            nextEl: nextRef.current
        },
        onInit: function() {
            setInit(true);
        },
        onBeforeInit: function(swiper) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
        },
        watchOverflow: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        autoHeight: autoHeight,
        onSwiper: function(swiper) {
            swiperRef.current = swiper;
        },
        allowTouchMove: false,
        children: children
    });
};
/* harmony default export */ var Content019_SwiperItem = (SwiperItem);

;// CONCATENATED MODULE: ./src/components/widgets/content/Content019/Content019.jsx










var Content019 = function(param) {
    var payload = param.payload;
    var ref;
    var slider = (ref = payload === null || payload === void 0 ? void 0 : payload.slider) !== null && ref !== void 0 ? ref : [];
    var ref1;
    var template = (ref1 = payload === null || payload === void 0 ? void 0 : payload.backgroundColor) !== null && ref1 !== void 0 ? ref1 : "light";
    var ref2;
    var imagePosition = (ref2 = payload === null || payload === void 0 ? void 0 : payload.imagePosition) !== null && ref2 !== void 0 ? ref2 : "right";
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var prevRef = (0,react.useRef)(null);
    var nextRef = (0,react.useRef)(null);
    var swiper1Ref = (0,react.useRef)(null);
    var swiper2Ref = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Content019_module_default()).wrapper, (Content019_module_default())[template]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            className: (Content019_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content019_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content019_module_default()).sliders,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Content019_module_default()).slider,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content019_SwiperItem, {
                                    prevRef: prevRef,
                                    nextRef: nextRef,
                                    swiperRef: swiper1Ref,
                                    autoHeight: true,
                                    paginationWrapper: (Content019_module_default()).pagination,
                                    children: slider.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                            className: (Content019_module_default()).slide,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                                    color: "dark",
                                                    className: (Content019_module_default()).title,
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                                    color: "dark",
                                                    className: (Content019_module_default()).subtitle,
                                                    children: item.subtitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                    color: "brand",
                                                    className: (Content019_module_default()).lead,
                                                    children: item.lead
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                                    color: "dark",
                                                    value: item.text
                                                })
                                            ]
                                        }, item.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Content019_module_default())["navigation-wrapper"], (0,_define_property/* default */.Z)({}, (Content019_module_default())["navigation-position"], imagePosition === "left")),
                                    children: [
                                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Content019_module_default()).pagination
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Content019_module_default())["slider-navigation"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: prevRef,
                                                    className: classnames_default()((Content019_module_default()).navigation, (Content019_module_default())["navigation-prev"]),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        className: (Content019_module_default()).icon,
                                                        name: "arrow_slider_prev"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: nextRef,
                                                    className: classnames_default()((Content019_module_default()).navigation, (Content019_module_default())["navigation-next"]),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        className: (Content019_module_default()).icon,
                                                        name: "arrow_slider_next"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Content019_module_default()).slider, (0,_define_property/* default */.Z)({}, (Content019_module_default())["slider-image"], imagePosition === "left")),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content019_SwiperItem, {
                                prevRef: prevRef,
                                nextRef: nextRef,
                                swiperRef: swiper2Ref,
                                children: slider === null || slider === void 0 ? void 0 : slider.map(function(item) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        className: (Content019_module_default()).slide,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                                            image: (ref = item.image) === null || ref === void 0 ? void 0 : ref[0],
                                            className: (Content019_module_default()).image
                                        })
                                    }, item.id);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Content019_Content019 = (Content019);


/***/ }),

/***/ 87580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content019_wrapper__PlDC_","light":"Content019_light__fyLb7","grey":"Content019_grey__vUICG","sliders":"Content019_sliders__Rybdh","slider":"Content019_slider__WIYmV","slider-image":"Content019_slider-image__Zl_gA","title":"Content019_title__cnI3z","subtitle":"Content019_subtitle__EN8aw","lead":"Content019_lead__maZZi","image":"Content019_image__yzF3w","navigation-wrapper":"Content019_navigation-wrapper__c8R5p","pagination":"Content019_pagination__L_YBH","slider-navigation":"Content019_slider-navigation__7aGwm","navigation":"Content019_navigation__8UUpG","navigation-prev":"Content019_navigation-prev__qb7Wq","navigation-next":"Content019_navigation-next__4gjAz","navigation-position":"Content019_navigation-position__x9h6R"};

/***/ }),

/***/ 17845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination-current":"SwiperItem_pagination-current__uApJO"};

/***/ })

}]);